import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DataService, DateService, HelperService, HTTPService } from 'app/services';
import { findIndex, trim } from 'lodash';
import { config, messages } from 'app/constants';
import { currency } from 'app/constants/currency.constants';
import { Subscription } from 'rxjs';
import { datetimeFormat } from 'app/constants/date-time-format';

@Component({
    selector: 'app-sms-credit-details-dialog',
    templateUrl: './sms-credit-details-dialog.component.html',
    styleUrls: ['./sms-credit-details-dialog.component.scss'],
    providers: [DialogService]
})
export class SMSCreditDetailsDialog implements OnInit, OnDestroy {
    isLoading: boolean = true;  // loading flag
    smsCreditHistory: any[] = [];   // sms credit history
    totalRecords: number = 0;   // total records  
    pageSize: number = config.pageSize; // default page size
    cols: any[] = [ // table columns
        { field: 'date', header: 'Date', width: '15%' },
        { field: 'user', header: 'User', width: '15%' },
        { field: 'details', header: 'Details', width: '50%' },
        { field: 'transaction', header: 'Transaction', width: '15%', align: 'right' },
        { field: 'monthlySMS', header: 'Free SMS Credits', width: '12%', align: 'right' },
        { field: 'purchasedSMS', header: 'Paid SMS Credits', width: '12%', align: 'right' },
    ];
    tableConfig = { // table configuration
        skip: 0,
        limit: config.pageSize,
        sortField: 'title',
        sortOrder: 1,
        search: '',
    };
    dataServiceSub: Subscription;

    smsDetails: any = {}; // sms details
    constructor(
        private httpService: HTTPService,       // http service     
        private helperService: HelperService,   // helper service
        private dynamicDialogRef: DynamicDialogRef, // dialog ref         
        private dynamicDialogConfig: DynamicDialogConfig,   // dialog config
        private dateService: DateService, // date service
        public dataService: DataService,

    ) { }

    ngOnInit(): void {
        const { smsDetails } = this.dynamicDialogConfig.data; // get sms details
        this.smsDetails = smsDetails;   // set sms details
        this.isLoading = true;  // set loading flag
        this.getHistory(); // get sms credit history
        this.getDataService(); // get data service
    }

    getDataService() {
        this.dataServiceSub = this.dataService.getData().subscribe(({ data }) => {
            if (!data) return;
            if (data.key === 'update-sms-credit-count' && data?.data?.smsDetails) {
                this.smsDetails.purchasedSMS += data?.data?.smsDetails?.defaultPurchasedSMS;
            }

        });
    }

    ngOnDestroy(): void {
        if (this.dataServiceSub) {
            this.dataServiceSub.unsubscribe();
        }
    }

    handleClose(isSuccess: boolean = false, data: any = {}) { // close dialog
        this.dynamicDialogRef.close({ isSuccess, data });
    }

    getHistory( // get sms credit history
        skip = this.tableConfig.skip,
        limit = config.pageSize,
        sortField: any = this.tableConfig.sortField,
        sortOrder = this.tableConfig.sortOrder,
    ) {
        const conf = { skip, limit, sortField, sortOrder };

        this.httpService.getSMSCreditHistory(conf).then(
            (data: any) => {
                this.smsCreditHistory = [];
                this.totalRecords = data.totalCount;
                if (data.records?.length) {
                    this.smsCreditHistory = this.formatSMSHistory(data.records);
                }
            },
            (error) => this.helperService.showToaster('error', error)
        ).finally(() => this.isLoading = false);
    }

    formatSMSHistory(data: any[]): any[] {  // format sms history
        return data.map(sms => {
            return {
                date: sms?.data?.date ? this.dateService.formatDate(
                    this.dateService.getCurrentDateTimeTz(new Date(sms?.data?.date).getTime()),
                    datetimeFormat.mmmdyyyy
                ) : '-',
                details: sms?.data?.details || '-',
                user: sms?.data?.user || this.helperService.getCompany().userName || '-',
                transaction: sms?.data?.transaction || 0,
                monthlySMS: sms?.data?.monthlySMS || 0,
                purchasedSMS: sms?.data?.purchasedSMS || 0,
                status: sms?.data?.status || '',
                _id: sms._id
            };
        });
    }

    paginate({ page, rows }: any) {     // pagination
        this.tableConfig.skip = page * this.tableConfig.limit;
        this.getHistory();
    }

    customSort({ sortField, sortOrder }) { // custom sort
        this.tableConfig.sortField = sortField;
        this.tableConfig.sortOrder = sortOrder;
        this.getHistory();
    }


    buyMoreSMSCredits() { // buy more sms credits
        this.httpService.buyMoreSMSCredits().then((response: any) => {
            const { url } = response?.hosted_page;
            window.open(url, '_blank');
        })
    }

}